import { ColumnDef } from "@tanstack/react-table";

// Type definitions
interface BankBranch {
	name: string;
}

interface MappingRow {
	id: number;
	mappingCode1: string;
	mappingCode2?: string;
	description: string;
	code: string;
	bankBranch?: BankBranch;
	sequenceNumber: number;
	createdAt?: string;
	modifiedAt?: string;
}

// ========== Mapping Columns ==========
export const mappingColumns: ColumnDef<MappingRow>[] = [
	{
		id: "mappingCode1",
		accessorKey: "mappingCode1",
		header: "Mapping Code 1",
		size: 200,
	},
	{
		id: "mappingCode2",
		accessorKey: "mappingCode2",
		header: "Mapping Code 2",
		size: 200,
		cell: ({ row }) => row.original.mappingCode2 || "--",
	},
	{
		id: "description",
		accessorKey: "description",
		header: "Description",
		size: 380,
	},
	{
		id: "code",
		accessorKey: "code",
		header: "Unique Code",
		size: 180,
	},
	{
		id: "bankBranch",
		accessorKey: "bankBranch",
		header: "Payment Institution Branch",
		size: 250,
		cell: ({ row }) => row.original.bankBranch?.name || "--",
	},
	{
		id: "sequenceNumber",
		accessorKey: "sequenceNumber",
		header: "Sequence Number",
		size: 200,
	},
];

export const mappingColumnVisibility: Record<string, boolean> = {
	mappingCode1: true,
	mappingCode2: true,
	description: true,
	code: true,
	bankBranch: true,
	sequenceNumber: true,
};
